import {createEntityAdapter, EntityAdapter, EntityState} from '@ngrx/entity';
import {ZbiorUszkodzen} from './zbiorUszkodzen';
import {aktualizujUszkodzenie, aktualizujZbiorUszkodzen, usunUszkodzenie, usunZbiorUszkodzen} from './zbiorUszkodzen.actions';
import {createReducer, on} from '@ngrx/store';

export interface ZbiorUszkodzenState extends EntityState<ZbiorUszkodzen> {}
export const adapterZbiorUszkodzen: EntityAdapter<ZbiorUszkodzen> = createEntityAdapter<ZbiorUszkodzen>();

export const initialZbiorUszkodzenState: ZbiorUszkodzenState =
  adapterZbiorUszkodzen.getInitialState();

export const zbiorUszkodzenReducer = createReducer<ZbiorUszkodzenState>(
  initialZbiorUszkodzenState,
  on(aktualizujZbiorUszkodzen, (state, action) => {
    return adapterZbiorUszkodzen.setOne(action.zbiorUszkodzen, state);
  }),
  on(usunZbiorUszkodzen, (state, action) => {
    return adapterZbiorUszkodzen.removeOne(action.id, state);
  }),
  on(aktualizujUszkodzenie, (state, action) => {
    const zbiorUszkodzen = {...state.entities[action.id]};
    const zaktualizowaneUszkodzenia = zbiorUszkodzen.uszkodzenia?.map(value => {
      if (value.identyfikator === action.uszkodzenie.identyfikator) {
        return action.uszkodzenie
      }
      return value
    });
    return adapterZbiorUszkodzen.updateOne(
      {
        id: action.id,
        changes: {uszkodzenia: zaktualizowaneUszkodzenia}
      },
      state
    );
  }),
  on(usunUszkodzenie, (state, action) => {
    const zbiorUszkodzen = {...state.entities[action.id]};
    const zaktualizowaneUszkodzenia = zbiorUszkodzen.uszkodzenia?.filter(u => u.identyfikator !== action.uszkodzenieId);
    if (zaktualizowaneUszkodzenia?.length === 0) {
      return adapterZbiorUszkodzen.removeOne(action.id, state);
    } else {
      return adapterZbiorUszkodzen.updateOne(
        {
          id: action.id,
          changes: {uszkodzenia: zaktualizowaneUszkodzenia }
        },
        state
      );
    }
  })
);
